module.exports = __webpack_public_path__ + "fonts/dljk.ee23ad9d.woff";